<template>
  <section class="options-selector">
    <p class="title">{{ options.title }}</p>

    <ul v-if="selection.length > 0">
      <li v-for="(image, index) in selection" :key="index">
        {{ image.name }}
      </li>
    </ul>
    <button
      v-if="selection.length < 1"
      class="option-button"
      @click="openDialog"
    >
      Maak een keuze
    </button>
    <button v-else class="option-button active" @click="openDialog">
      Keuze aanpassen
    </button>
  </section>
</template>

<script>
import ImageSelectorDialog from './ImageSelectorDialog.vue'
import { toRaw } from 'vue'
export default {
  name: 'ImageSelector',
  props: {
    options: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selection: []
    }
  },
  methods: {
    openDialog() {
      this.$modal.show(
        ImageSelectorDialog,
        {
          selection: this.selection,
          options: this.options,
          callback: (model) => {
            this.selection = toRaw(model)
            this.$emit('setImages', {
              title: this.options.title,
              images: this.selection
            })
          }
        },
        {
          width: 480,
          height: 'auto',
          scrollable: true,
          adaptive: true,
          clickToClose: false
        }
      )
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 500;
}

.title {
  margin-bottom: 10px;
}

ul {
  list-style-type: disc;
  list-style-position: inside;
  padding-bottom: 10px;
  line-height: 23px;
}

li {
}

.options-selector {
  margin-bottom: 20px;
}

.option-button {
  background-color: #e7e7e7;
  padding: 8px 15px;
}
</style>
